import { withDefaultProps } from '../../utils/with-default-props';
import React from 'react';
import { withNativeProps } from '../../utils/native-props';
var classPrefix = "adm-grid";
var defaultProps = {
  gap: 0
};
export var Grid = withDefaultProps(defaultProps)(function (props) {
  var gapStyle = {};
  var gap = props.gap;

  if (gap) {
    var _ref = Array.isArray(gap) ? gap : [gap, gap],
        horizontalGap = _ref[0],
        verticalGap = _ref[1];

    gapStyle = Object.assign(Object.assign({}, gapStyle), {
      '--vertical-gap': typeof verticalGap === 'number' ? verticalGap + "px" : verticalGap,
      '--horizontal-gap': typeof horizontalGap === 'number' ? horizontalGap + "px" : horizontalGap
    });
  }

  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix,
    style: Object.assign(Object.assign({}, gapStyle), {
      '--columns': props.columns
    })
  }, props.children));
});
export var GridItem = withDefaultProps({
  span: 1
})(function (props) {
  var itemStyle = {
    '--item-span': props.span
  };
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-item",
    style: itemStyle
  }, props.children));
});